import { animate, style, transition, trigger } from '@angular/animations';

export const fadeInOutAnimation = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-3px)' }),
    animate('0.3s ease-in-out', style({ opacity: 1, transform: 'translateY(0px)' })),
  ]),
  transition(':leave', [animate('0.3s ease-in-out', style({ opacity: 0, transform: 'translateY(3px)' }))]),
]);
